import { EventEmitter } from '@angular/core';
import { GRID_VIEW, LIST_VIEW } from '../../../core/helpers/theme-config';
import { BehaviorSubject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
var ViewTypeSwitchComponent = /** @class */ (function () {
    function ViewTypeSwitchComponent(store) {
        this.store = store;
        this.onTypeSwitched = new EventEmitter();
        this.onToggleFullWidthView = new EventEmitter();
        this.fullWidthView$ = new BehaviorSubject(false);
        store
            .pipe(select(fromBase.isFullWidthViewEnabled))
            .subscribe(this.fullWidthView$);
    }
    ViewTypeSwitchComponent.prototype.toggleFullWidthView = function () {
        this.onToggleFullWidthView.emit(!this.fullWidthView$.getValue());
    };
    Object.defineProperty(ViewTypeSwitchComponent.prototype, "isGridView", {
        get: function () {
            return this.viewType === GRID_VIEW;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewTypeSwitchComponent.prototype, "isListView", {
        get: function () {
            return this.viewType === LIST_VIEW;
        },
        enumerable: true,
        configurable: true
    });
    ViewTypeSwitchComponent.prototype.setGrid = function () {
        if (this.isListView)
            this.onTypeSwitched.emit(GRID_VIEW);
    };
    ViewTypeSwitchComponent.prototype.setList = function () {
        if (this.isGridView)
            this.onTypeSwitched.emit(LIST_VIEW);
    };
    return ViewTypeSwitchComponent;
}());
export { ViewTypeSwitchComponent };
